class Index {
  constructor() {
    this.hero = document.querySelector(".hero");
    this.quantity = 50;
    this.ceiling = 100;
    this.mbdImage = document.getElementById("animationDemo");
    this.objects = document.querySelectorAll(".slide-in-object");
    this.imageWrapper = document.querySelectorAll(".image-wrapper");
    this.imageBorder = document.querySelector(".image-border");
    this.txtName = document.getElementById("name");
    this.txtEmail = document.getElementById("email");
    this.txtMessage = document.getElementById("message");
    this.btnSend = document.getElementById("btnSend");
    this.toastEl = document.getElementById("liveToast");
    this.#init();
  }

  #init() {
    this.#loadSlideInAnimation();
    this.#animateImages();
    this.#animateAlbum();
    this.#addLinksEventListener();
    this.#sendMessage();
  }

  #addLinksEventListener() {
    const threshold = 0.1;
    document.addEventListener("DOMContentLoaded", function () {
      const divisions = document.querySelectorAll("div[id]");
      const links = document.querySelectorAll(".navbar-nav .nav-link");
      const removeActiveClass = () => {
        links.forEach((link) => link.classList.remove("active"));
      };

      const addActiveClass = (id) => {
        removeActiveClass();
        const currentNavLink = document.querySelector(
          `.navbar-nav .nav-link[href="#${id}"]`
        );
        if (currentNavLink) {
          currentNavLink.classList.add("active");
        }
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const sectionId = entry.target.getAttribute("id");
              addActiveClass(sectionId);
            }
          });
        },
        {
          threshold: threshold,
        }
      );
      divisions.forEach((section) => observer.observe(section));
    });
  }

  #loadSlideInAnimation() {
    document.addEventListener("DOMContentLoaded", () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      this.objects.forEach((object) => {
        observer.observe(object);
      });
    });
  }

  #animateImages() {
    document.addEventListener("DOMContentLoaded", () => {
      this.#changeBorderColor();
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            } else {
              entry.target.classList.remove("visible");
            }
          });
        },
        { threshold: 0.5 }
      );
      this.imageWrapper.forEach((img) => {
        observer.observe(img);
      });
    });
  }

  #changeBorderColor() {
    const colors = ["#c0eba6", "#3C3D37"];
    const increment = 1;
    const milliseconds = 3000;
    let currentColorIndex = 0;

    if (this.imageBorder) {
      setInterval(() => {
        currentColorIndex = (currentColorIndex + increment) % colors.length;
        this.imageBorder.style.borderColor = colors[currentColorIndex];
      }, milliseconds);
    }
  }

  #animateAlbum() {
    document.addEventListener("DOMContentLoaded", () => {
      const album = document.querySelector(".album");
      const cards = document.querySelectorAll(".card");
      const threshold = 0.1;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              album.classList.add("visible");
              animateCards();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: threshold }
      );

      observer.observe(album);

      function animateCards() {
        const timeout = 100;
        cards.forEach((card, index) => {
          setTimeout(() => {
            card.classList.add("visible");
          }, index * timeout);
        });
      }
    });
  }

  #getEmailTemplate() {
    return {
      service_id: "service_z9wibge",
      template_id: "template_y5499vd",
      user_id: "gg29ZiD4BQUCkQ-9P",
      template_params: {
        from_name: `${this.txtName.value}, ${this.txtEmail.value}`,
        message: this.txtMessage.value,
      },
    };
  }

  #sendMessage() {
    this.btnSend.addEventListener("click", async (event) => {
      event.preventDefault();

      const form = this.btnSend.closest("form");
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      try {
        await axios.post(
          "https://api.emailjs.com/api/v1.0/email/send",
          this.#getEmailTemplate(),
          { headers: { "Content-Type": "application/json" } }
        );

        this.txtName.value = "";
        this.txtEmail.value = "";
        this.txtMessage.value = "";

        const toast = new bootstrap.Toast(this.toastEl);
        toast.show();
      } catch (err) {}
    });
  }
}

export default new Index();
